<div #mainContent class="main-content" [@viewState]="{value: asideOpen, params: {asideWidth: asideWidth}}"
     [ngStyle]="{overflowY: overlay ? 'hidden' : 'scroll'}">
  <div class="overlay pointer" [hidden]="!overlay" (click)="onOverlayClick()"></div>
  <ng-content></ng-content>
</div>

